// extracted by mini-css-extract-plugin
module.exports = {"tipe-terapi":"__152yQQn_","title":"qydxXE_5","description":"iQcN8_ZA","subtitle":"VX0PrPav","cardType":"xC1cmVBi","cardDescription":"aWAxo0X5","link":"yppIxb00"};